// src/components/NotFoundIllustration.tsx
//
// La elección aleatoria vive aquí, en un client component aparte, para que not-found.tsx
// (la página en sí) siga siendo un Server Component estático — Next.js la pre-renderiza en
// build time y la sirve desde caché/CDN sin tocar el servidor en cada visita, igual que
// hoy. Si el random se resolviera directo en not-found.tsx (Server Component sin
// "use client"), Next.js lo evaluaría UNA sola vez durante el build, no por visita — se
// vería siempre la misma "aleatoria" hasta el próximo deploy, no aleatoriedad real.
//
// El estado inicial es null (no `ILLUSTRATIONS[0]`) a propósito: así el servidor nunca
// "decide" ninguna imagen y el cliente nunca tiene que descartar una descarga ya en curso
// de la imagen equivocada — solo se pide UNA imagen por visita (la elegida), nunca las 4.
// El placeholder del mismo alto/ancho evita que aparezca un salto de layout mientras se
// resuelve (útil solo esa fracción de segundo antes del useEffect).
"use client";

import { useEffect, useState } from 'react';
import Image from 'next/image';

const ILLUSTRATIONS = [
  '/devmonkeys/404_devmonkeys.webp',
  '/devmonkeys/devmonkeys_404_1.webp',
  '/devmonkeys/devmonkeys_404_2.webp',
  '/devmonkeys/devmonkeys_404_3.webp',
];

export default function NotFoundIllustration() {
  const [src, setSrc] = useState<string | null>(null);

  useEffect(() => {
    setSrc(ILLUSTRATIONS[Math.floor(Math.random() * ILLUSTRATIONS.length)]);
  }, []);

  if (!src) {
    return <div className="w-[350px] h-[200px] max-w-full mx-auto" aria-hidden="true" />;
  }

  return (
    <Image
      src={src}
      alt="Monos desarrolladores desconcertados por página no encontrada"
      width={350}
      height={200}
      className="rounded-lg shadow-xl mx-auto"
      unoptimized
      priority
    />
  );
}
